// Action types for loading Utility API data
export const LOAD_TODAY_INFORMATION_SUCCESS = "LOAD_TODAY_INFORMATION_SUCCESS";
export const LOAD_ACTIVE_CONSULTANT_LIST_SUCCESS = "LOAD_ACTIVE_CONSULTANT_LIST_SUCCESS";
export const LOAD_UTILIZATIO_REQUEST_STATUSES_SUCCESS = "LOAD_UTILIZATIO_REQUEST_STATUSES_SUCCESS";
export const LOAD_HOURS_TRANSACTION_TYPES_SUCCESS = "LOAD_HOURS_TRANSACTION_TYPES_SUCCESS";

// Action types for managing available hours API data
export const LOAD_CONSULTANTS_SUCCESS = "LOAD_CONSULTANTS_SUCCESS";
export const LOAD_AVAILABLE_HOURS_SUCCESS = "LOAD_AVAILABLE_HOURS_SUCCESS";
export const EDIT_AVAILABLE_HOURS_SUCCESS = "EDIT_AVAILABLE_HOURS_SUCCESS";
export const LOAD_AVAILABLE_HOURS_HISTORY_SUCCESS = "LOAD_AVAILABLE_HOURS_HISTORY_SUCCESS";
export const LOAD_AVAILABLE_HOURS_NOTES_SUCCESS = "LOAD_AVAILABLE_HOURS_NOTES_SUCCESS";
export const SAVE_AVAILABLE_HOURS_NOTE_SUCCESS = "SAVE_AVAILABLE_HOURS_NOTE_SUCCESS";
export const UPDATE_AVAILABLE_HOURS_NOTE_SUCCESS = "UPDATE_AVAILABLE_HOURS_NOTE_SUCCESS";
export const REMOVE_AVAILABLE_HOURS_NOTE_SUCCESS = "REMOVE_AVAILABLE_HOURS_NOTE_SUCCESS";

// Action types for managing hour utilization request API data
export const LOAD_HOUR_UTILIZATION_REQUEST_SUCCESS = "LOAD_HOUR_UTILIZATION_REQUEST_SUCCESS";
export const SAVE_HOUR_UTILIZATION_REQUEST_SUCCESS = "SAVE_HOUR_UTILIZATION_REQUEST_SUCCESS";
export const UPDATE_HOUR_UTILIZATION_REQUEST_SUCCESS = "UPDATE_HOUR_UTILIZATION_REQUEST_SUCCESS";
export const CANCEL_HOUR_UTILIZATION_REQUEST_SUCCESS = "CANCEL_HOUR_UTILIZATION_REQUEST_SUCCESS";
export const ACCEPT_HOUR_UTILIZATION_REQUEST_SUCCESS = "ACCEPT_HOUR_UTILIZATION_REQUEST_SUCCESS";
export const SAVE_RATE_AGNOSTIC_HOUR_UTILIZATION_REQUEST_SUCCESS =
  "SAVE_RATE_AGNOSTIC_HOUR_UTILIZATION_REQUEST_SUCCESS";

// Action types fo manageing eligable hours API data
export const LOAD_ELIGABLE_HOURS_SUCCESS = "LOAD_ELIGABLE_HOURS_SUCCESS";
export const CLEAR_ELIGABLE_HOURS = "CLEAR_ELIGABLE_HOURS";


// Action types for loading utilization API data
export const LOAD_UTILIZATION_SUCCESS = "LOAD_UTILIZATION_SUCCESS";
export const CLEAR_UTILIZATION = "CLEAR_UTILIZATION";

// Action for tracking ongoing API calls
export const ADD_ACTIVE_API_CALL = "ADD_ACTIVE_API_CALL";

//Action types for PTO API activity
export const LOAD_PTO_DETAILS_SUCCESS = "LOAD_PTO_DETAILS_SUCCESS";

//Action types for Presidents Club API activity
export const LOAD_PRES_CLUB_REVENUE_SUCCESS = "LOAD_PRES_CLUB_REVENUE_SUCCESS";
export const LOAD_PRES_CLUB_UTILIZATION_SUCCESS = "LOAD_PRES_CLUB_UTILIZATION_SUCCESS";
export const LOAD_PRES_CLUB_UTILIZATION_ADMIN_SUCCESS = "LOAD_PRES_CLUB_UTILIZATION_ADMIN_SUCCESS";
export const LOAD_PRES_CLUB_REVENUE_ADMIN_SUCCESS = "LOAD_PRES_CLUB_REVENUE_ADMIN_SUCCESS";

// Action types for managing frequesntly asked questions
export const LOAD_FAQS_SUCCESS = "LOAD_FAQS_SUCCESS";
export const SAVE_NEW_FAQ_SUCCESS = "SAVE_NEW_FAQ_SUCCESS";
export const UPDATE_FAQ_SUCCESS = "UPDATE_FAQ_SUCCESS";
export const UPDATE_USEFULNESS_SCORE_SUCCESS = "UPDATE_USEFULNESS_SCORE_SUCCESS";
export const REMOVE_FAQ_SUCCESS = "REMOVE_FAQ_SUCCESS";

// Action types for User profile and settings
export const LOAD_USER_PROFILE_SUCCESS = "LOAD_USER_PROFILE_SUCCESS";
export const SET_GHOST_USER = "SET_GHOST_USER";
export const TOGGLE_DARK_THEME = "TOGGLE_DARK_THEME";
export const GET_BLACKOUT_PERIOD_ACTIVE_SUCCESS = "GET_BLACKOUT_PERIOD_ACTIVE_SUCCESS";
export const TOGGLE_BLACKOUT_PERIOD_SUCCESS = "TOGGLE_BLACKOUT_PERIOD_SUCCESS";

//Action types for accrual calculator
export const LOAD_ACCRUAL_CALCULATOR_HISTORY = "LOAD_ACCRUAL_CALCULATOR_HISTORY";
export const RUN_ACCRUAL_CALCULATOR = "RUN_ACCRUAL_CALCULATOR";
export const LOAD_CALCULABLE_QUARTERS = "LOAD_CALCULABLE_QUARTERS";

//impersonation
export const SET_IMPERSONATION = 'SET_IMPERSONATION';
export const CLEAR_IMPERSONATION = 'CLEAR_IMPERSONATION';